/* Mandrelekids bed add-ons: live total + bundled add-to-cart (multi-currency aware) */
(function () {
  var root = document.querySelector('[data-mk-addons]');
  var form = document.getElementById('product-form');
  if (!form) return;

  var variantInput = document.getElementById('variant-id');
  var totalEl = root ? root.querySelector('[data-mk-total]') : null;

  // -------- Money formatting (currency-switcher aware) --------
  function detectFormatFromSample(sample) {
    if (!sample) return null;
    var m = sample.match(/(\D*?)([\d][\d.,\s']*)(\D*)$/);
    if (!m) return null;
    var num = m[2];
    var lastComma = num.lastIndexOf(',');
    var lastDot = num.lastIndexOf('.');
    var decSep = null;
    // Decimal sep only if the last separator has 1-2 trailing digits.
    if (lastComma > -1 && /,\d{1,2}$/.test(num) && lastComma > lastDot) decSep = ',';
    else if (lastDot > -1 && /\.\d{1,2}$/.test(num) && lastDot > lastComma) decSep = '.';
    var thouSep = decSep === ',' ? '.' : ',';
    return { prefix: m[1], suffix: m[3], decSep: decSep, thouSep: thouSep, raw: num };
  }

  // Parse a money string -> cents (in whatever currency the string is in).
  function parseMoneyToCents(sample) {
    var fmt = detectFormatFromSample(sample);
    if (!fmt) return 0;
    var num = fmt.raw;
    var cents;
    if (fmt.decSep) {
      var parts = num.split(fmt.decSep);
      var intPart = parts[0].replace(/[^\d]/g, '');
      var fracPart = (parts[1] || '').replace(/[^\d]/g, '');
      if (fracPart.length === 1) fracPart += '0';
      if (fracPart.length === 0) fracPart = '00';
      if (fracPart.length > 2) fracPart = fracPart.slice(0, 2);
      cents = parseInt(intPart || '0', 10) * 100 + parseInt(fracPart, 10);
    } else {
      // No decimal — treat as whole units.
      cents = parseInt(num.replace(/[^\d]/g, ''), 10) * 100;
    }
    return cents || 0;
  }

  function formatWithSample(cents, fmt) {
    var v = (cents / 100);
    var parts = v.toFixed(2).split('.');
    var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, fmt.thouSep || ',');
    var dec = fmt.decSep || '.';
    return fmt.prefix + intPart + dec + parts[1] + fmt.suffix;
  }

  function getSampleFormat() {
    var sampleEl = document.querySelector('#price-display .product-price') ||
                   document.querySelector('[data-mk-addon-price]');
    var sample = sampleEl ? sampleEl.textContent.replace(/^\+/, '').trim() : '';
    return { fmt: detectFormatFromSample(sample), sample: sample };
  }

  function money(cents) {
    var s = getSampleFormat();
    if (s.fmt) return formatWithSample(cents, s.fmt);
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, (window.Shopify && Shopify.money_format) || '${{amount}}');
    }
    return (cents / 100).toFixed(2);
  }

  // Read bed price in cents (in displayed currency).
  // Priority: parse the rendered #price-display (always matches what the customer sees,
  // including after currency switch). Fall back to __mkVariantPrices.
  function readBedPrice() {
    var priceEl = document.querySelector('#price-display .product-price');
    if (priceEl) {
      var c = parseMoneyToCents(priceEl.textContent || '');
      if (c) return c;
    }
    var vid = variantInput && variantInput.value;
    if (window.__mkVariantPrices && vid && window.__mkVariantPrices[vid] != null) {
      return window.__mkVariantPrices[vid];
    }
    return 0;
  }

  // Read addon price in cents. data-price is set by Liquid in displayed currency at render time.
  function readAddonPrice(li) {
    // Prefer the visible "+€xx" text so it always matches the dropdown / currency switch.
    var priceEl = li.querySelector('[data-mk-addon-price]');
    if (priceEl) {
      var c = parseMoneyToCents((priceEl.textContent || '').replace(/^\+/, ''));
      if (c) return c;
    }
    return parseInt(li.getAttribute('data-price'), 10) || 0;
  }

  function selectedAddons() {
    if (!root) return [];
    var out = [];
    root.querySelectorAll('[data-mk-addon]').forEach(function (li) {
      var qty = 0;
      var chk = li.querySelector('[data-mk-check]');
      var qtyInput = li.querySelector('[data-mk-qty]');
      if (li.hasAttribute('data-mk-choice')) {
        // Free choice (e.g. entrance side): always included, as whatever option is selected.
        var sel = li.querySelector('[data-mk-addon-select]');
        var opt = sel && sel.options[sel.selectedIndex];
        qty = opt && !opt.disabled ? 1 : 0;
      } else if (chk) qty = chk.checked ? 1 : 0;
      else if (qtyInput) qty = Math.max(0, parseInt(qtyInput.value, 10) || 0);
      if (qty > 0) {
        out.push({
          id: li.getAttribute('data-variant-id'),
          quantity: qty,
          price: readAddonPrice(li),
          title: li.getAttribute('data-title')
        });
      }
    });
    return out;
  }

  function recalc() {
    if (!totalEl) return;
    var sum = readBedPrice();
    selectedAddons().forEach(function (a) { sum += a.price * a.quantity; });
    totalEl.textContent = money(sum);
  }

  function syncVariantSelect(sel) {
    var opt = sel.options[sel.selectedIndex];
    if (!opt) return;
    var li = sel.closest('[data-mk-addon]');
    if (!li) return;
    var price = parseInt(opt.getAttribute('data-price'), 10) || 0;
    li.setAttribute('data-variant-id', sel.value);
    li.setAttribute('data-price', price);
    var priceEl = li.querySelector('[data-mk-addon-price]');
    if (priceEl) {
      var pm = (opt.getAttribute('data-price-money') || '').replace(/<[^>]*>/g, '').trim();
      if (!pm) pm = money(price);
      priceEl.textContent = '+' + pm;
    }
    // Picking an option from the dropdown means the customer wants the add-on, so tick it.
    var chk = li.querySelector('[data-mk-check]');
    if (chk && !chk.checked) chk.checked = true;
  }

  if (root) {
    root.querySelectorAll('[data-mk-addon-select]').forEach(function (sel) {
      sel.addEventListener('change', function () { syncVariantSelect(sel); recalc(); });
    });
    root.addEventListener('change', recalc);
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-step]');
      if (!btn) return;
      var li = btn.closest('[data-mk-addon]');
      var input = li && li.querySelector('[data-mk-qty]');
      if (!input) return;
      var step = parseInt(btn.getAttribute('data-step'), 10) || 0;
      var max = parseInt(input.getAttribute('max'), 10) || 99;
      var v = (parseInt(input.value, 10) || 0) + step;
      if (v < 0) v = 0;
      if (v > max) v = max;
      input.value = v;
      recalc();
    });
  }

  var priceObserverTarget = document.getElementById('price-display');
  if (priceObserverTarget && 'MutationObserver' in window) {
    new MutationObserver(recalc).observe(priceObserverTarget, { childList: true, subtree: true, characterData: true });
  }

  recalc();

  // Collect all properties[...] fields from the product form (Entrance, Legs,
  // Drawers, Rail height, RAL colour, ...) so the bundled AJAX add-to-cart
  // carries them exactly like a native form submit would.
  function collectFormProps() {
    var props = {};
    form.querySelectorAll('[name^="properties["]').forEach(function (el) {
      var m = el.name.match(/^properties\[(.+)\]$/);
      if (!m) return;
      if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
      var v = (el.value || '').trim();
      if (v) props[m[1]] = v;
    });
    return props;
  }

  function buildItems() {
    var bedId = variantInput && variantInput.value;
    if (!bedId) return null;
    var bundleKey = 'b_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
    var bedProps = collectFormProps();
    bedProps._bundle = bundleKey;
    bedProps._bundle_role = 'bed';
    var items = [{ id: bedId, quantity: 1, properties: bedProps }];
    selectedAddons().forEach(function (a) {
      items.push({ id: a.id, quantity: a.quantity, properties: { _bundle: bundleKey, _bundle_parent: 'true' } });
    });
    return items;
  }

  function postCartAdd(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (data) { return { ok: r.ok, data: data }; });
    });
  }

  form.addEventListener('submit', function (e) {
    // If the custom-options validation already blocked this submit
    // (missing Entrance/Legs/RAL etc.), don't add anything to cart.
    if (e.defaultPrevented) return;
    var addons = selectedAddons();
    if (!addons.length) return;
    e.preventDefault();
    var btn = document.getElementById('add-to-cart-btn');
    var orig = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = 'Adding…'; }
    var items = buildItems();
    if (!items) return;
    postCartAdd(items).then(function (res) {
      if (res.ok) window.location.href = '/cart';
      else {
        if (btn) { btn.disabled = false; btn.innerHTML = orig; }
        alert((res.data && (res.data.description || res.data.message)) || 'Could not add to cart.');
      }
    }).catch(function () {
      if (btn) { btn.disabled = false; btn.innerHTML = orig; }
      alert('Network error. Please try again.');
    });
  });

  var buyNow = document.getElementById('mk-buy-now-btn');
  if (buyNow) {
    buyNow.addEventListener('click', function (e) {
      var addons = selectedAddons();
      if (!addons.length) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      // Same required-option validation as the normal submit path.
      var missing = [];
      form.querySelectorAll('input[type="hidden"][data-required]').forEach(function (inp) {
        if (!inp.value) missing.push(inp.getAttribute('data-label'));
      });
      var ralWrap = document.getElementById('mk-ral-wrap');
      var ralInput = document.getElementById('mk-ral-input');
      if (ralWrap && ralInput && !ralWrap.hidden && ralInput.value.trim() === '') {
        missing.push(ralInput.closest('.product-option') ? 'RAL colour' : 'RAL colour');
      }
      if (missing.length) {
        alert('Please choose: ' + missing.join(', '));
        return;
      }
      var orig = buyNow.innerHTML;
      buyNow.disabled = true;
      buyNow.innerHTML = '<span>Processing…</span>';
      var items = buildItems();
      postCartAdd(items).then(function (res) {
        if (res.ok) window.location.href = '/checkout';
        else {
          buyNow.disabled = false; buyNow.innerHTML = orig;
          alert((res.data && (res.data.description || res.data.message)) || 'Could not add to cart.');
        }
      }).catch(function () {
        buyNow.disabled = false; buyNow.innerHTML = orig;
        alert('Network error. Please try again.');
      });
    }, true);
  }
})();
